import { combineReducers } from 'redux';

import byId from './byId';
import field from './field';
import ids from './ids';
import signingProgressType from './signingProgressType';

export default combineReducers({
  byId,
  field,
  ids,
  signingProgressType,
});
